/**
 * Filter/Ordering Mappings for Matters DataTable
 *
 * Simple lookup tables for cases where column IDs don't match backend keys.
 * Most columns use their ID directly - these maps only handle the exceptions.
 */

import { MatterColumnIds } from './columnConfig';

// Column ID → Backend Key (for filters)

const FILTER_KEY_OVERRIDES: Record<string, string> = {
  [MatterColumnIds.FIRM_NAME]: 'firm',
};

const REVERSE_FILTER_KEY_OVERRIDES: Record<string, string> = {
  firm: MatterColumnIds.FIRM_NAME,
};

// Column ID → Ordering Field (for sorting)

const ORDERING_FIELD_OVERRIDES: Record<string, string> = {
  [MatterColumnIds.ATTORNEY]: 'representing_attorney__last_name',
  [MatterColumnIds.PARALEGAL]: 'firm__managing_paralegal__first_name',
  [MatterColumnIds.CASE_MANAGER]: 'case_manager_first_name',
  [MatterColumnIds.PREFERRED_LANGUAGE]: 'clients__preferred_language',
};

const REVERSE_ORDERING_OVERRIDES: Record<string, string> = {
  representing_attorney__last_name: MatterColumnIds.ATTORNEY,
  firm__managing_paralegal__first_name: MatterColumnIds.PARALEGAL,
  case_manager_first_name: MatterColumnIds.CASE_MANAGER,
  // Matter Name multi-option sorting
  clients__first_name: MatterColumnIds.NAME,
  clients__last_name: MatterColumnIds.NAME,
  clients__preferred_language: MatterColumnIds.PREFERRED_LANGUAGE,
};

// Utility Functions

export function getBackendFilterKey(columnId: string): string {
  return FILTER_KEY_OVERRIDES[columnId] ?? columnId;
}

export function getColumnIdFromBackend(backendKey: string): string {
  return REVERSE_FILTER_KEY_OVERRIDES[backendKey] ?? backendKey;
}

export function getOrderingField(columnId: string): string {
  return ORDERING_FIELD_OVERRIDES[columnId] ?? columnId;
}

export function getColumnIdFromOrdering(orderingField: string): string {
  return REVERSE_ORDERING_OVERRIDES[orderingField] ?? orderingField;
}
